export const API_BASE_URL = process.env.REACT_APP_API_URL;
export const API_V1_URL = `${process.env.REACT_APP_API_URL}/api/v1`;

// API Endpoints
export const env = {
  //SCOREBOARD
  API_URL_SCOREBOARD: `${API_V1_URL}/scoreboard`,
  API_URL_SCOREBOARD_LOGIN: `${API_V1_URL}/scoreboard/login`,
  API_URL_SCOREBOARD_ME: `${API_V1_URL}/scoreboard/me`,
  API_URL_SCOREBOARD_TEAMS: `${API_V1_URL}/scoreboard/teams`,
};
